import {
	useCartActions,
	useCartContext,
} from "../../../contexts/CartServiceContext/CartServiceContext";
import { useCatalogueContext } from "../../../contexts/CatalogueContext/CatalogueContext";
import { IOosItemDetail } from "./helpers/oosDetectionHelpers";
import { useOosDetectionLogic, useRemoveOosItems } from "./useOosDetectionLogic";

interface IOosDetectionResult {
	hasOosItems: boolean;
	oosItemNames: string[];
	oosItemDetails: IOosItemDetail[];
	removeOosItems: () => void;
}

const useOosDetection = (): IOosDetectionResult => {
	const { state: cart } = useCartContext((state) => state.cart);
	const { state: catalogueProducts } = useCatalogueContext((state) => state.products);
	const cartActions = useCartActions();

	// Use extracted testable logic
	const { catalogueMap, hasOosItems, oosItemNames, oosItemDetails } = useOosDetectionLogic(
		cart,
		catalogueProducts
	);

	// Use extracted removeOosItems logic
	const removeOosItems = useRemoveOosItems(cart, catalogueMap, cartActions);

	return {
		hasOosItems,
		oosItemNames,
		oosItemDetails,
		removeOosItems,
	};
};

export default useOosDetection;
